import type { ConversationState } from '../state/conversationStore';

interface Props {
  state: ConversationState;
  onReset: () => void;
  disabled?: boolean;
}

export function HistoryActions({ state, onReset, disabled }: Props) {
  const onExport = () => {
    const blob = new Blob([JSON.stringify({ turns: state.turns, userEvents: state.userEvents }, null, 2)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `phase4a-history-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // App passes disabled=true while status==='inferring' so a mid-stream
  // reset can't clear activeAssistantId and silently drop an in-flight turn,
  // and export doesn't capture a placeholder turn with empty text.
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <button onClick={onReset} disabled={disabled}>
        🗑 リセット
      </button>
      <button onClick={onExport} disabled={disabled}>
        📤 Export JSON
      </button>
    </div>
  );
}
